import { Button, TextField } from "@mui/material";

import { Box, Typography } from "@mui/material";

import { Modal } from "@mui/material";

import { Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ModalStyle } from "../Signups/CreationSelectionModal";
import ProBox from "../Signups/ProBox";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import PricingBox from "../Lessons/PricingBox";
import { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import RecurringEvent from "./RecurringEvent";
import recurringUTCConverter from "./recurringUTCConverter";
import { proMappingInterface } from "../WeekAtAGlance/EventCreationBanner";
import DateTimeLoc from "./DateTimeLoc";

export const recurringDaysAvailable = [
  {
    label: "Monday",
    value: 0,
  },
  {
    label: "Tuesday",
    value: 1,
  },
  {
    label: "Wednesday",
    value: 2,
  },
  {
    label: "Thursday",
    value: 3,
  },
  {
    label: "Friday",
    value: 4,
  },
  {
    label: "Saturday",
    value: 5,
  },
  {
    label: "Sunday",
    value: 6,
  },
];

type dropdownItem = {
  label: string;
  value: number;
};

function RegisterLessonModal({
  registerModal,
  setRegisterModal,
  devPort,
  clubId,
  proMapping,
  onRefresh,
  modalType = "save",
  lessonToEdit = null,
  setLessonToEdit,
  setLessonToDeleteId,
  setLessonDeleteMessage,
}: {
  registerModal: boolean;
  setRegisterModal: (value: boolean) => void;
  devPort: string;
  clubId: number;
  proMapping: proMappingInterface;
  onRefresh: () => void;
  modalType?: "save" | "update";
  lessonToEdit?: any;
  setLessonToEdit?: (value: any) => void;
  setLessonToDeleteId?: (value: any) => void;
  setLessonDeleteMessage?: (value: string) => void;
}) {
  const isEditMode = modalType === "update";
  const [registerDate, setRegisterDate] = useState("");
  const [recurringEndDate, setRecurringEndDate] = useState("");
  const [registerStartTime, setRegisterStartTime] = useState<Dayjs | null>(
    null
  );
  const [registerField, setRegisterField] = useState("");
  const [selectedPrice, setSelectedPrice] = useState<dropdownItem | null>(null);
  const [selectedPackages, setSelectedPackages] = useState<string>("");
  const [recipient, setRecipient] = useState<dropdownItem | null>(null);
  //const [recurringEvent, setRecurringEvent] = useState(false);
  const [recurringDays, setRecurringDays] = useState<number[]>([]);
  const [registerModalPrice, setRegisterModalPrice] = useState(false);
  const [idPro, setIdPro] = useState();
  const [registerSlots, setRegisterSlots] = useState(2);

  function resetRecurringParams() {
    //setRecurringEvent(false);
    setRegisterDate("");
    /*const utc_start_date = moment(moment().format("YYYY-MM-DD") + "T00:00")
      .utc()
      .format("YYYY-MM-DDTHH:mm");
    setStartDate(utc_start_date);*/
    setRegisterField("");
    setRegisterStartTime(null);
    setRecurringEndDate("");
    setRecurringDays([]);
    setIdPro(null);
    setSelectedPrice(null);
    setSelectedPackages("");
    setRegisterSlots(2);
    if (setLessonToEdit) {
      setLessonToEdit(null);
    }
  }

  useEffect(() => {
    if (isEditMode && lessonToEdit && registerModal) {
      setRegisterDate(moment(lessonToEdit.raw_date).format("YYYY-MM-DD"));
      setRegisterStartTime(dayjs(lessonToEdit.raw_date));
      setRegisterField(lessonToEdit.field_location || "");
      setRegisterSlots(lessonToEdit.slots);
      setIdPro(lessonToEdit.proId);
    }
  }, [isEditMode, lessonToEdit, registerModal]);

  function validFirstPage() {
    if (
      !registerDate ||
      !registerStartTime ||
      !moment(registerDate).isValid() ||
      !moment(registerStartTime).isValid()
    ) {
      window.alert("Enter a date and time");
    } else if (registerSlots <= 0) {
      window.alert("Enter a valid number of students");
    } else if (!registerField) {
      window.alert("Enter a field name");
    } else if (!idPro) {
      window.alert("Select a coach for the lesson");
    } else {
      return true;
    }
    return false;
  }
  function validSecondPage() {
    console.log(selectedPrice, selectedPackages, recipient);
    if ((selectedPrice || selectedPackages.length > 0) && !recipient) {
      window.alert("Select a recipient for the lesson");
      return false;
    } else {
      return true;
    }
  }
  function verifyFirstPageFields() {
    if (validFirstPage()) {
      setRegisterModal(false);
      setRegisterModalPrice(true);
    }
  }
  function registerLesson() {
    console.log(registerSlots);
    if (validFirstPage() && validSecondPage()) {
      const [recurring_integer, utc_lesson_time, utc_end_date] = recurringUTCConverter(
        registerDate,
        registerStartTime,
        recurringDays,
        recurringEndDate
      );
      const lesson_data = {
        club_id: clubId,
        lesson_datetime: utc_lesson_time,
        field_location: registerField,
        coach_id: idPro,
        max_participants: registerSlots,
        recurring_end_date: utc_end_date,
        recurring_days: recurring_integer,
        lesson_price: selectedPrice ? selectedPrice.value : null,
        lesson_packages: selectedPackages ? selectedPackages : null,
        lesson_recipient: recipient ? recipient.value : null,
      };
      console.log(lesson_data);
      fetch(devPort + "add_lesson", {
        mode: "cors",
        credentials: "include",
        method: "POST",
        body: JSON.stringify(lesson_data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("Generated Lesson");
          console.log(data);
          setRegisterModalPrice(false);
          resetRecurringParams();
          onRefresh();
          /*filterGames();
          if (data && data["message"]) {
            setMessageContent(data["message"]);
            setAlertMessage(true);
          }*/
        });
    }
  }

  function updateLesson() {
    if (validFirstPage()) {
      const [, utc_lesson_time] = recurringUTCConverter(
        registerDate,
        registerStartTime,
        [],
        ""
      );
      const lesson_data = {
        lesson_id: lessonToEdit.id,
        club_id: clubId,
        lesson_datetime: utc_lesson_time,
        field_location: registerField,
        coach_id: idPro,
        max_participants: registerSlots,
      };
      fetch(devPort + "update_lesson", {
        mode: "cors",
        credentials: "include",
        method: "POST",
        body: JSON.stringify(lesson_data),
      })
        .then((response) => {
          return response.json();
        })
        .then(() => {
          setRegisterModal(false);
          resetRecurringParams();
          onRefresh();
        });
    }
  }

  return (
    <Stack>
      <Modal
        open={registerModalPrice}
        onClose={() => {
          setRegisterModalPrice(false);
        }}
        aria-labelledby="Lesson Registration2"
        aria-describedby="Create new lesson2"
        style={{ overflow: "scroll" }}
      >
        <Box sx={ModalStyle}>
          <Stack spacing={2}>
            <Typography id="lesson-creation" variant="h6" component="h2">
              Create New Lesson 2/2
            </Typography>
            <PricingBox
              devPort={devPort}
              clubId={clubId}
              selectedPrice={selectedPrice}
              setSelectedPrice={setSelectedPrice}
              selectedPackages={selectedPackages}
              setSelectedPackages={setSelectedPackages}
              recipient={recipient}
              setRecipient={setRecipient}
              proMapping={proMapping}
              tableType="Lesson"
            />
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="success"
                  onClick={registerLesson}
                >
                  Save Lesson
                </Button>
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setRegisterModalPrice(false);
                    resetRecurringParams();
                  }}
                >
                  <CloseIcon />
                  Close
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
      <Modal
        open={registerModal}
        onClose={() => {
          setRegisterModal(false);
        }}
        aria-labelledby="Lesson Registration"
        aria-describedby="Create new lesson"
        style={{ overflow: "scroll" }}
      >
        <Box sx={ModalStyle}>
          <Stack spacing={2}>
            <DateTimeLoc
              modalMode={isEditMode ? "Edit Lesson" : "Create New Lesson 1/2"}
              registerDate={registerDate}
              registerStartTime={registerStartTime}
              registerField={registerField}
              setRegisterDate={setRegisterDate}
              setRegisterStartTime={setRegisterStartTime}
              setRegisterField={setRegisterField}
            />
            {/*<Typography id="lesson-creation" variant="h6" component="h2">
              Create New Lesson 1/2
            </Typography>
            <DatePicker
              data-testid="lesson-date"
              onChange={(event: Dayjs | null) => {
                if (event) {
                  setRegisterDate(moment(event["$d"]).format("YYYY-MM-DD"));
                }
              }}
            />
            <TimePicker
              data-testid="lesson-time"
              label="Set Start Time"
              onChange={(event: Dayjs | null) => {
                setRegisterStartTime(event);
              }}
            />
            <TextField
              data-testid="lesson-field-name"
              id="field-name"
              label="Field Name"
              variant="filled"
              onChange={(event: any) => {
                setRegisterField(event.target.value);
              }}
            />*/}
            <div>Max Number of Students</div>
            <Box sx={{ width: 325 }}>
              <TextField
                id="number-students"
                label="Max Number of Students"
                data-testid="number-students"
                value={registerSlots}
                onChange={(newValue: any) =>
                  setRegisterSlots(newValue.target.value)
                }
                style={{ width: "100%" }}
                type="number"
                //slotProps={{
                //  inputLabel: {
                //    shrink: true,
                //  },
                //}}
              />
            </Box>
            <ProBox
              key={`coach-${isEditMode ? lessonToEdit?.id : "new"}`}
              devPort={devPort}
              clubId={clubId}
              setIdPro={setIdPro}
              proRequest={isEditMode ? lessonToEdit?.proId : undefined}
              boxLabel="Select Coach"
              //refresh={players}
            />
            {!isEditMode && (
              <RecurringEvent
                recurringDays={recurringDays}
                setRecurringDays={setRecurringDays}
                setRecurringEndDate={setRecurringEndDate}
                mode="Lesson"
              />
            )}
            {isEditMode && setLessonToDeleteId && (
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  if (setLessonDeleteMessage) {
                    setLessonDeleteMessage(
                      "with " + lessonToEdit.pro + " at " + lessonToEdit.time
                    );
                  }
                  setLessonToDeleteId(lessonToEdit.id);
                  setRegisterModal(false);
                }}
              >
                <DeleteIcon />
                Delete Lesson
              </Button>
            )}
            <Grid container spacing={2}>
              <Grid size={{ xs: 6 }}>
                {isEditMode ? (
                  <Button
                    style={{ width: "100%" }}
                    variant="contained"
                    color="success"
                    onClick={updateLesson}
                  >
                    Update Lesson
                  </Button>
                ) : (
                  <Button
                    style={{ width: "100%" }}
                    variant="contained"
                    color="primary"
                    onClick={verifyFirstPageFields} //registerLesson}
                  >
                    <NavigateNextIcon />
                    Next
                  </Button>
                )}
              </Grid>
              <Grid size={{ xs: 6 }}>
                <Button
                  style={{ width: "100%" }}
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setRegisterModal(false);
                    resetRecurringParams();
                  }}
                >
                  <CloseIcon />
                  Close
                </Button>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Modal>
    </Stack>
  );
}

export default RegisterLessonModal;
